.menu {
	overflow-y: auto;
	min-height: 0;
	flex: 1 1 auto;
	background-color: var(--elevation-default);
	scrollbar-width: thin;
	scrollbar-color: var(--border-primary) transparent;
}

.menu::-webkit-scrollbar {
	width: 8px;
}

.menu::-webkit-scrollbar-track {
	background: transparent;
}

.menu::-webkit-scrollbar-thumb {
	background-color: var(--border-primary);
	border-radius: 4px;
}

.menu::-webkit-scrollbar-thumb:hover {
	background-color: var(--content-tertiary);
}

.option {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px;
	outline: none;
	cursor: pointer;
}

.option[data-hovered] {
	background-color: var(--elevation-medium);
}

.option[data-disabled] {
	color: var(--content-tertiary);
	cursor: not-allowed;
}

.icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 14px;
	height: 14px;
}

.icon svg {
	width: 14px;
	height: 14px;
}
